import React, { useEffect, useState } from 'react'
import { Box, IconButton, MenuItem } from '@mui/material'
import { useRouteQuery, useTranslator } from '@/hooks'
import { InputField } from '../common'
import { BalanceStatusEnum, useBalanceStatusOptions } from '@/@data'

interface BalanceStatusSelectionProps {
  value: string
  onSelect?: (status: BalanceStatusEnum) => void
  disabled?: boolean
  required?: boolean
  label?: string
  className?: string
  fullWidth?: boolean
  placeholder?: string
  excludeGuestStatuses?: boolean
}

const BalanceStatusSelection = ({
  onSelect,
  disabled = false,
  required = false,
  label = '',
  className = '',
  fullWidth = true,
  placeholder = '',
  excludeGuestStatuses = false
}: BalanceStatusSelectionProps) => {
  const { __ } = useTranslator()

  const statusOptions = useBalanceStatusOptions()

  const { searchQuery } = useRouteQuery()
  const [value, setValue] = useState<string>()

  useEffect(() => {
    const status = searchQuery.get('balance_status') || ''

    setValue(status)
  }, [searchQuery])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value as BalanceStatusEnum

    onSelect?.(selectedValue)
  }

  const handleClear = () => {
    setValue('')
    onSelect?.(undefined as any)
  }

  const guestStatusValues = ['GUEST', 'GUEST_WAITING']

  const filteredStatusOptions = excludeGuestStatuses
    ? statusOptions.filter(option => !guestStatusValues.includes(option.value))
    : statusOptions

  return (
    <InputField
      select
      fullWidth={fullWidth}
      label={label}
      value={value || ''}
      onChange={handleChange}
      disabled={disabled}
      required={required}
      className={className}
      placeholder={placeholder}
      slotProps={{
        input: {
          endAdornment: value ? (
            <Box mr={5}>
              <IconButton size='small' onClick={handleClear} aria-label='clear selection' tabIndex={-1}>
                <i className='tabler-x text-[16px] text-textPrimary'></i>
              </IconButton>
            </Box>
          ) : null
        },
        select: {
          displayEmpty: true,
          renderValue: (selected: any) => {
            if (!selected) {
              return <span style={{ color: '#aaa' }}>{placeholder || label || __('Select status')}</span>
            }

            const found = statusOptions.find(option => option.value === selected)

            return found ? found.label : selected
          }
        }
      }}
      sx={{
        '& .MuiSelect-select': {
          textAlign: 'left'
        },
        '& .MuiInputBase-root': {
          height: '38px'
        }
      }}
    >
      <MenuItem value=''>{placeholder || 'All statuses'}</MenuItem>
      {filteredStatusOptions.map(option => (
        <MenuItem key={option.value || '123'} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </InputField>
  )
}

export default BalanceStatusSelection
